var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.500244 8C0.500244 3.85786 3.85811 0.5 8.00024 0.5C12.1424 0.5 15.5002 3.85786 15.5002 8C15.5002 12.1421 12.1424 15.5 8.00024 15.5C3.85811 15.5 0.500244 12.1421 0.500244 8Z","stroke":"#D0D5DD"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }